export const DASHBOARD_COLORS = {
  CHART_COLORS: ['primary', 'secondary', 'success', 'warning', 'error', 'info'],
  TREND_COLORS: {
    up: 'success',
    down: 'error',
    stable: 'warning'
  }
};

export const CHART_CONFIG = {
  CIRCULAR_PROGRESS_SIZE: 120,
  CIRCULAR_PROGRESS_THICKNESS: 4,
  LINEAR_PROGRESS_HEIGHT: 8,
  METRIC_TILE_AVATAR_SIZE: 56,
  CHART_HEIGHT: 400
};

export const ANIMATION_CONFIG = {
  HOVER_TRANSFORM: 'translateY(-8px)',
  HOVER_DURATION: '0.3s',
  ELEVATION_HOVER: 12,
  ELEVATION_DEFAULT: 3
};

export const BREAKPOINTS = {
  MOBILE_FAB_DISPLAY: { xs: 'flex', md: 'none' },
  DESKTOP_ONLY: { xs: 'none', md: 'block' }
}; 